module.exports = __webpack_public_path__ + "img/zwcx.9d0770e0.png";